/* Responsibility: Gather common functionality for communicating with the server */
import ajax from './ajax.js';

function isList (list) {
    return !!list &&
        typeof list === 'object' &&
        typeof list.length === 'number' &&
        !list.tagName;
}

function mapParams (data) {
    const ajaxUrlParams = [];
    let x;

    function addParam (key, val) {
        ajaxUrlParams.push({ name: key, value: val });
    }

    for (const key in data) {
        if (data.hasOwnProperty(key)) {
            if (isList(data[key])) {
                for (x = 0; x < data[key].length; x += 1) {
                    addParam(key, data[key][x]);
                }
            } else {
                addParam(key, data[key]);
            }
        }
    }
    return ajaxUrlParams;
}

class Server {
    constructor (contextPath) {
        this.contextPath = contextPath;
    }

    loadJsonCors (urlSegment, data, callback) {
        ajax.load({
            url: this.contextPath + urlSegment,
            dataType: 'json',
            method: 'get',
            data: mapParams(data),
            crossOrigin: true,
            callback,
        });
    }

    loadJSON (urlSegment, data, callback) {
        ajax.load({
            url: this.contextPath + urlSegment,
            dataType: 'json',
            method: 'get',
            data: mapParams(data),
            callback,
        });
    }

    postJSON (urlSegment, data, callback) {
        ajax.load({
            url: this.contextPath + urlSegment,
            dataType: 'json',
            method: 'post',
            data: mapParams(data),
            callback,
        });
    }
}

export default Server;



// WEBPACK FOOTER //
// /mnt/build-dir/TRAVELAPP-FRONTPAGEDEPLOY-FRONTPAGEPIPELINE/shared/overlay/src/main/webapp/scripts/lib/modules/server.js